import router from "./router";
import i18n from "./i18n";

export const consultantModuleRouter = router;
export const consultantModuleI18n = i18n;
